export default "__VITE_ASSET__DLpnO6IY__"